import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'

type Props = {
  amount: number
  quantity: number
  shoppingBagQuantity?: number
}

const OrderCardFooter: FC<Props> = React.memo((props) => {
  const { amount, quantity, shoppingBagQuantity } = props
  return (
    <div className={styles.order__footer}>
      <FlexRow justifyContent={'start'}>
        <span className={styles.order__footer__quantity}>合計個数：{quantity}個</span>
        {typeof shoppingBagQuantity !== 'undefined' && (
          <>
            <Spacer size={8} />
            <span className={styles.order__footer__bag}>(レジ袋：{shoppingBagQuantity}枚)</span>
          </>
        )}
      </FlexRow>
      <Spacer size={12} />
      <p className={styles.order__footer__amount}>総売上(税込)：{amount.toLocaleString()}円</p>
    </div>
  )
})

export default OrderCardFooter
